import React from 'react'
import './services.css'
import Info from './Info'
import styledSectionBreak from '../assets/lineBreak.svg'

const Services = (props) => {

  const openLightbox = props.openLightbox

  return (
    <section className='services section' id='services'>
        <h2 className="section__title">Services</h2>
        <span className="section__subtitle"><img src={styledSectionBreak} className='styledLineBreak' alt="" /></span>

        <div className="services__data">
            <Info openLightbox={openLightbox} />
        </div>
    </section>
  )
}

export default Services
